export const HierarchicalSearchBarName = 'hierarchicalSearchBarComponent';
